export default "__VITE_ASSET__BuFlrWYS__"